import React, { useEffect, useRef, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import { useForm } from 'react-hook-form';
import { useRecoilValue } from 'recoil';
import { authAtom } from '../../_state';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import FilledInput from '@mui/material/FilledInput';
import IconButton from '@mui/material/IconButton';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import InputAdornment from '@mui/material/InputAdornment';
import Typography from '@mui/material/Typography';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import 'dayjs/locale/ko';
import { Tooltip } from '@mui/material';

const COUPON_PRICE = 200000;

export default function ActiveCodeApplication(props) {
  const auth = useRecoilValue(authAtom);
  const { username, companyName, companyNo, eMail, cellPhoneNumber } = auth;

  const {
    handleSubmit,
    register,
    clearErrors,
    reset,
    formState: { errors, isDirty, isSubmitting }
  } = useForm({
    defaultValues: {
      acUserName: username,
      acCompanyName: companyName,
      accountantPhone: cellPhoneNumber,
      accountantEmail: eMail,
      acCompanyNo: companyNo
    }
  });

  const { ref: fileRef, onChange: onFileChange, ...fileRest } = register('datas.businessRegist');

  const { open, handleClose, getDataList } = props;
  const [discount, setDiscount] = useState(0);
  const [couponQuantity, setCouponQuantity] = useState(0);
  const [buyQuantity, setBuyQuantity] = useState(1);
  const [amount, setAmount] = useState(COUPON_PRICE);
  const [startDate, setStartDate] = useState();
  const [orderCheck, setOrderCheck] = useState(false);
  const [managerMailSend, setManagerMailSend] = useState(true);
  const [datas, setDatas] = useState({});

  const [acUserName, setacUserName] = useState(null);
  const [acCompanyName, setacCompanyName] = useState(null);
  const [accountantPhone, setaccountantPhone] = useState(null);
  const [accountantEmail, setaccountantEmail] = useState(null);
  const [acCompanyNo, setAcCompanyNo] = useState(null);

  const fileInputRef = useRef(null);

  const handleChange = (e) => {
    setBuyQuantity(e.target.value || 1);
    setAmount(COUPON_PRICE * e.target.value);
  };
  const couponOrder = async (data) => {
    let formData = new FormData();
    const config = {
      headers: { 'content-type': 'multipart/form-data' }
    };
    formData.append('quantity', buyQuantity);
    formData.append('startDate', startDate);
    formData.append('managerMailSend', managerMailSend);
    formData.append('businessRegist', fileInputRef.current.files[0]);
    formData.append('acUserName', data?.acUserName);
    formData.append('acCompanyName', data?.acCompanyName);
    formData.append('accountantPhone', data?.accountantPhone);
    formData.append('accountantEmail', data?.accountantEmail);
    if (data?.acCompanyNo) {
      const tAcCompanyNo = data?.acCompanyNo;
      formData.append('acCompanyNo', `${tAcCompanyNo.substr(0, 3)}-${tAcCompanyNo.substr(3, 2)}-${tAcCompanyNo.substr(5, 5)}`);
    }
    return await axios.post(`/api/coupon/order`, formData, config);
  };

  const handleChangeOrderCheck = (e) => {
    setOrderCheck(e.target.checked);
  };

  const handleChangeMailSendCheck = (e) => {
    setManagerMailSend(e.target.checked);
  };

  const onSubmit = async (data) => {
    if (!isSubmitting) {
      await couponOrder(data)
        .then((response) => {
          alert(response.data.message);
          handleClose();
          getDataList();
        })
        .catch((error) => {
          alert(error.response.data.message);
          console.log(error.response);
        });
    }
  };

  const getCouponQuantity = async () => {
    const response = await axios.get(`/api/coupon/count/${auth.companyId}`);
    setCouponQuantity(response.data.couponQuantity);
  };

  const onClickFileDelete = (evt) => {
    fileInputRef.current.value = '';
    setDatas({ ...datas, fileNameOrigin: '' });
  };

  const onClickFileUpload = async (evt) => {
    if (!!evt.target.id) {
      fileInputRef.current.click();
    }
  };

  const handleChangeFileInput = (e) => {
    setDatas({ ...datas, fileNameOrigin: e.target.files.item(0).name });
  };

  useEffect(async () => {
    if (open) {
      setDatas({});
      setBuyQuantity(1);
      setAmount(COUPON_PRICE);
      setDiscount(0);
      setOrderCheck(false);
      setManagerMailSend(true);
      setStartDate(new Date());
      clearErrors();
      reset();
      await getCouponQuantity();
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="draggable-dialog-title">
      <Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate sx={{ mt: 1 }}>
        <DialogTitle id="draggable-dialog-title">쿠폰 구매</DialogTitle>
        <DialogContent dividers>
          <Box>
            <TableContainer component={'div'}>
              <Table size="small">
                <TableRow>
                  <TableCell>회사</TableCell>
                  <TableCell>
                    {companyName} ({companyNo})
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>담당자</TableCell>
                  <TableCell>{username}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>현재 쿠폰</TableCell>
                  <TableCell>{couponQuantity || 0}장</TableCell>
                </TableRow>
              </Table>
            </TableContainer>
          </Box>
          <Box>
            <TableContainer component={'div'}>
              <Table size="small">
                <TableRow>
                  <TableCell>구매 수량</TableCell>
                  <TableCell colSpan={2}>
                    <TextField
                      id="count"
                      type="number"
                      variant="outlined"
                      size="small"
                      sx={{ width: 200 }}
                      inputProps={{ defaultValue: 1, min: 1, max: 300, style: { textAlign: 'right' }, pattern: '[0-9]*' }}
                      autoFocus
                      value={buyQuantity || 1}
                      error={!!errors.quantity}
                      helperText={errors.quantity && errors.quantity.message}
                      {...register('quantity', {
                        required: '쿠폰 수량을 입력해주세요.'
                      })}
                      onChange={handleChange}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colspan={2} align={'center'}>
                    <Typography variant="body2" display="inline" gutterBottom sx={{ mt: 2, mb: 2, color: 'red' }}>
                      ※ 쿠폰 사용 기한은 가격 변동으로 인해 2024년 6월까지입니다.
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>총 금액</TableCell>
                  <TableCell>
                    {[Math.floor(COUPON_PRICE * buyQuantity)].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원
                    <Typography variant="body2" display="inline" gutterBottom sx={{ ml: 1, color: 'red' }}>
                      (VAT 별도)
                    </Typography>
                  </TableCell>
                </TableRow>
                {discount !== 0 && (
                  <TableRow>
                    <TableCell>할인 금액</TableCell>
                    <TableCell>
                      {[Math.floor(((COUPON_PRICE * buyQuantity) / 100) * discount)].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원
                      <Tooltip title={`수량 및 등급에 따른 할인`}>
                        <IconButton>
                          <HelpOutlineRoundedIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                )}
                <TableRow>
                  <TableCell>최종 금액</TableCell>
                  <TableCell>{[Math.floor(amount + amount * 0.1)].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={2}>
                    <Typography variant="h6">세금계산서 받을 담당자</Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>회사명</TableCell>
                  <TableCell>
                    <TextField
                      size="small"
                      error={!!errors.acCompanyName}
                      helperText={errors.acCompanyName && errors.acCompanyName.message}
                      value={acCompanyName}
                      fullWidth
                      {...register('acCompanyName', {
                        required: '세금계산서를 받을 회사명을 입력해주세요.'
                      })}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>이름</TableCell>
                  <TableCell>
                    <TextField
                      size="small"
                      error={!!errors.acUserName}
                      helperText={errors.acUserName && errors.acUserName.message}
                      value={acUserName}
                      fullWidth
                      {...register('acUserName', {
                        required: '세금계산서를 받을 담당자명을 입력해주세요.'
                      })}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>전화번호</TableCell>
                  <TableCell>
                    <TextField
                      size="small"
                      error={!!errors.accountantPhone}
                      helperText={errors.accountantPhone && errors.accountantPhone.message}
                      value={accountantPhone}
                      fullWidth
                      {...register('accountantPhone', {
                        required: '세금계산서를 받을 담당자 핸드폰번호를 입력해주세요.'
                      })}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>세금계산서 이메일</TableCell>
                  <TableCell>
                    <TextField
                      size="small"
                      error={!!errors.accountantEmail}
                      helperText={errors.accountantEmail && errors.accountantEmail.message}
                      value={accountantEmail}
                      fullWidth
                      {...register('accountantEmail', {
                        required: '세금계산서를 받을 담당자 이메일을 입력해주세요.'
                      })}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>사업자 등록번호</TableCell>
                  <TableCell>
                    <TextField
                      size="small"
                      error={!!errors.acCompanyNo}
                      helperText={errors.acCompanyNo && errors.acCompanyNo.message}
                      value={acCompanyNo}
                      fullWidth
                      {...register('acCompanyNo', {
                        required: '사업자 등록 번호를 입력해주세요.'
                      })}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={2}>
                    <FormControl fullWidth variant="filled" margin="dense" size="small">
                      <InputLabel htmlFor="businessRegist">사업자등록증</InputLabel>
                      <FilledInput
                        id="businessRegist"
                        size="small"
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton edge="end" onClick={onClickFileDelete}>
                              {datas?.fileNameOrigin && <HighlightOffIcon />}
                            </IconButton>
                          </InputAdornment>
                        }
                        fullWidth
                        variant="standard"
                        margin="dense"
                        inputProps={{ readOnly: true }}
                        value={datas?.fileNameOrigin || ''}
                        onClick={onClickFileUpload}
                        {...register('datas.fileNameOrigin')}
                      />
                    </FormControl>
                    <Button id="fileUploadButton" margin="dense" variant="contained" fullWidth onClick={onClickFileUpload}>
                      사업자등록증 업로드
                    </Button>
                    <input
                      type="file"
                      accept="application/pdf"
                      style={{ display: 'none' }}
                      ref={(e) => {
                        fileRef(e);
                        fileInputRef.current = e; // you can still assign to ref
                      }}
                      onChange={handleChangeFileInput}
                      {...fileRest}
                    />
                  </TableCell>
                </TableRow>
              </Table>
            </TableContainer>
          </Box>
          <FormControlLabel control={<Checkbox checked={managerMailSend} />} id="privateTerms" name="privateTerms" label="매니저 전체 메일 발송" onChange={handleChangeMailSendCheck} />
          <br />
          <FormControlLabel control={<Checkbox checked={orderCheck} />} id="privateTerms" name="privateTerms" label="쿠폰을 사용하시면 환불이 불가합니다." onChange={handleChangeOrderCheck} />
        </DialogContent>
        <DialogActions>
          <Button type="submit" variant="contained" color="primary" disabled={!orderCheck}>
            구매
          </Button>
          <Button variant="outlined" color="success" onClick={handleClose}>
            닫기
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
